/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Assistant_Activity_CancelledInputs */



/**
* | output |
* | --- |
* | "{tool} was not run" |
*
* @param {Assistant_Activity_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_cancelled = /** @type {((inputs: Assistant_Activity_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.tool} n'a pas été exécuté`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.tool} wurde nicht ausgeführt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.tool} non è stato eseguito`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.tool} не был запущен`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.tool} no se ejecutó`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.tool} 未运行`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tool} は実行されませんでした`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tool} नहीं चलाया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.tool} não foi executado`)
	return /** @type {LocalizedString} */ (`${i?.tool} was not run`)
});